import { Link } from 'react-router-dom';
import { rankingMovies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function MovieRanking() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              电影<span className="text-primary-500">排行榜</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">根据用户评分精选的TOP10高分电影</p>
          </div>
          <Link
            to="/category/drama"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
          {rankingMovies.slice(0, 10).map((movie, index) => (
            <MovieCard key={movie.id} movie={movie} showRank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}